<template>
  <button
    class="button-interactive rounded-full shadow-md text-primary-500 hover:bg-primary-500 hover:text-white w-8 h-8 flex justify-center items-center"
  >
    <edit-icon class="w-4 stroke-current" />
  </button>
</template>